module.exports = __webpack_public_path__ + "img/tooltip_02-vallone-feinsteinzeug-gres-oro-venato.a4df7248.jpg";